import { motion } from 'framer-motion';
import styled from 'styled-components';

import { mediaDesktop } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

interface WrapperProps {}

interface SettingRowProps {
  opacity?: number;
}

export const Wrapper = styled.div<WrapperProps>`
  display: block;
  position: relative;

  overflow-x: hidden;
`;

export const Container = styled.div`
  color: ${colors.black};
  padding: 88px 16px 121px;

  button {
    margin-top: 40px;
    float: right;
  }

  ${mediaDesktop(`
    padding: 144px 122px 170px;
  `)};
`;

export const SettingsWrapper = styled(motion.div)`
  width: 100%;
`;

export const SettingRow = styled.div<SettingRowProps>`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  margin: 16px 0 0;

  cursor: pointer;

  ${({ opacity }) => opacity && `opacity: ${opacity}`};
`;
